import { ConfidenceLevelProps } from 'vet-bones/design-system/components';

export type CompetencyQuestion = {
  id: string;
  question: string;
  evaluation?: CompetencyQuestionEvaluation;
};

export type CompetencyQuestionEvaluation = {
  score: number;
  explanation: string;
  tags: CompetencyQuestionEvaluationTag[];
  query: string | null;
};

export const enum CompetencyQuestionEvaluationTag {
  AMBIGUITY = 'AMBIGUITY',
  MISSING_MODEL = 'MISSING_MODEL',
  MISSING_DATA = 'MISSING_DATA',
}

export const CONFIDENCE_LEVEL_BY_SCORE: Record<
  number,
  ConfidenceLevelProps['level']
> = {
  1: 'low',
  2: 'medium',
  3: 'high',
};

export type EvaluationSummary = {
  summary: string;
  issues: EvaluationSummaryIssue[];
};

export type EvaluationSummaryIssue = {
  type: EvaluationSummaryIssueType;
  target: string;
  label: string;
  explanation: string;
};

export const enum EvaluationSummaryIssueType {
  ADD_DATASET = 'ADD_DATASET',
  ADD_QUESTIONS = 'ADD_QUESTIONS',
  UNANSWERED_QUESTION = 'UNANSWERED_QUESTION',
  UNLINKED_CONCEPT = 'UNLINKED_CONCEPT',
  UNUSED_DATASET = 'UNUSED_DATASET',
  GENERIC = 'GENERIC',
}
